// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { LabCardType } from '../../types/Model';

export interface LabRelatedRequestPayload {
  id: string;
  loadingType: LoadingType;
}
export interface LabRelatedSuccessPayload {
  LabRelatedData: LabCardType[];
  id: string;
  loadingType: LoadingType;
}

export interface LabRelatedFailPayload {
  error: Error;
}

export const getLabRelatedActions = createAsyncAction(
  'elearning/GET_LAB_RELATED',
  'elearning/GET_LAB_RELATED_SUCCESS',
  'elearning/GET_LAB_RELATED_FAIL'
)<
  LabRelatedRequestPayload,
  LabRelatedSuccessPayload,
  LabRelatedFailPayload
>();
